import { render, staticRenderFns } from "./front-blog.vue?vue&type=template&id=4ea3f912&scoped=true&"
import script from "./front-blog.vue?vue&type=script&lang=js&"
export * from "./front-blog.vue?vue&type=script&lang=js&"
import style0 from "./front-blog.vue?vue&type=style&index=0&id=4ea3f912&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ea3f912",
  null
  
)

export default component.exports